/**
 * Stable per-browser guest ID used for rate-limiting AI generation when
 * the user is not signed in. Stored in localStorage; if missing or storage
 * is unavailable, a new one is generated each call (acceptable fallback).
 */

const KEY = "gtp.guest_id";

function uuid(): string {
  if (typeof crypto !== "undefined" && "randomUUID" in crypto) {
    return crypto.randomUUID();
  }
  return `g_${Date.now()}_${Math.random().toString(36).slice(2, 10)}`;
}

export function getGuestId(): string {
  try {
    const existing = localStorage.getItem(KEY);
    if (existing) return existing;
    const fresh = uuid();
    localStorage.setItem(KEY, fresh);
    return fresh;
  } catch {
    return uuid();
  }
}
